﻿(function () {
    'use strict';
    var serviceId = 'repositories';

    angular.module('app.services').factory(serviceId, repositories);

    repositories.$inject = ['$injector'];

    function repositories($injector) {
        var service = {
            getRepo: function (repoName) {
                var fullRepoName = 'repository.' + repoName.toLowerCase();
                var Repo = $injector.get(fullRepoName);
                return new Repo();
            }
        };

        return service;
    }
})();